export default "__VITE_ASSET__f79ae893__"